import { parseLength } from "../../utils/units.js";

class EdgeToSteelDialogComponent extends HTMLElement {

  topEdge = '5'
  bottomEdge = '5'
  leftEdge = '5'
  rightEdge = '5'

  constructor() {
    super()
    document.addEventListener('project-loaded', async (event) => this.onProjectLoaded(event.detail.geometry), true)
  }

  /**
   * Create our view model and configure the view
   * @param {Geometry} model
   * 
   */
   onProjectLoaded(model) {
    this.topEdge = `${model.topEdge}`
    this.bottomEdge = `${model.bottomEdge}`
    this.leftEdge = `${model.leftEdge}`
    this.rightEdge = `${model.rightEdge}`
    this.configure()
  }

  configure() {
    document.getElementById('top-edge').value = this.topEdge
    document.getElementById('bottom-edge').value = this.bottomEdge
    document.getElementById('left-edge').value = this.leftEdge
    document.getElementById('right-edge').value = this.rightEdge
  }

  publishUpdate() {
    const event = new CustomEvent('edge-to-steel-dialog-update', { detail: this });
    this.dispatchEvent(event)
  }

  onBlur() {
    let value = parseLength(document.getElementById("top-edge").value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('edge-to-steel-validation').classList.remove('d-none')
      document.getElementById('edge-to-steel-validation').innerHTML = 'Enter a valid Top Edge. e.g. 5 or 5 in'
      return
    }
    document.getElementById('edge-to-steel-validation').classList.add('d-none')
    this.topEdge = document.getElementById('top-edge').value
    
    value = parseLength(document.getElementById("bottom-edge").value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('edge-to-steel-validation').classList.remove('d-none')
      document.getElementById('edge-to-steel-validation').innerHTML = 'Enter a valid Bottom Edge. e.g. 5 or 5 in'
      return
    }
    document.getElementById('edge-to-steel-validation').classList.add('d-none')
    this.bottomEdge = document.getElementById('bottom-edge').value

    value = parseLength(document.getElementById("left-edge").value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('edge-to-steel-validation').classList.remove('d-none')
      document.getElementById('edge-to-steel-validation').innerHTML = 'Enter a valid Left Edge. e.g. 5 or 5 in'
      return
    }
    document.getElementById('edge-to-steel-validation').classList.add('d-none')
    this.leftEdge = document.getElementById('left-edge').value

    value = parseLength(document.getElementById("right-edge").value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('edge-to-steel-validation').classList.remove('d-none')
      document.getElementById('edge-to-steel-validation').innerHTML = 'Enter a valid Right Edge. e.g. 5 or 5 in'
      return
    }
    document.getElementById('edge-to-steel-validation').classList.add('d-none')
    this.rightEdge = document.getElementById('right-edge').value
    this.publishUpdate()
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="card panel-primary">
      <div class="card-body hidden-print">
        <div style="margin:10px 0 10px 0;">
          <span>Top Edge (in) <input style="width:50px;" class='text-center' id="top-edge" type="text" 
            name="top-edge" value="${this.topEdge}" /></span>
          <span class="pull-right">Bottom Edge (in) <input style="width:50px;" class='text-center' id="bottom-edge" type="text"
            name="bottom-edge" value="${this.bottomEdge}" /></span>
        </div>
        <div>
          <span>Left Edge (in) <input style="width:50px;" class='text-center' id="left-edge" type="text" 
            name="left-edge" value="${this.leftEdge}" /></span>
          <span class="pull-right">Right Edge (in) <input style="width:50px;" class='text-center' id="right-edge" type="text"
            name="right-edge" value="${this.rightEdge}" /></span>
        </div>
        <div style="margin-top:10px;" id="edge-to-steel-validation" class="alert alert-danger d-none">
        </div>
      </div>
    </div>
  </div>
    `

    document.getElementById('top-edge').onblur = (() => this.onBlur())
    document.getElementById('bottom-edge').onblur = (() => this.onBlur())
    document.getElementById('left-edge').onblur = (() => this.onBlur())
    document.getElementById('right-edge').onblur = (() => this.onBlur())

    this.configure()
  }
}

customElements.define('edge-to-steel-dialog-component', EdgeToSteelDialogComponent)